import Vue from 'vue';

import store from './store.js';
import './plugins/bootstrap-vue';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

import App from './App.vue';
import client from 'api-client';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckSquare, faDownload, faArrowUp, faArrowDown, faPlus, faTimes, faCalendarAlt, faBroadcastTower, faSatelliteDish, faExchangeAlt, faCode, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheckSquare, faSquare, faDownload, faArrowUp, faArrowDown, faPlus, faTimes, faCalendarAlt, faBroadcastTower, faSatelliteDish, faExchangeAlt, faCode, faExclamationTriangle);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false

Vue.config.errorHandler = function(err, vm, info) {
  if (isDatePickerError(vm)) {
    // ignore error for wrong datepicker value (it will be validated server-side in any case)
    return;
  }
  // open error message popup
  document.dispatchEvent(new CustomEvent('showMessage', {
    detail: {
      message: err.message,
      options: {
        title: 'JavaScript error',
        variant: 'danger'
      }
    }
  }));
  client.reportError({
    message: err.message,
    stack: err.stack || null
  });
  // stop loading animation
  let event = new CustomEvent('loading');
  event.value = false;
  document.dispatchEvent(event);
  console.error(err);
};

function isDatePickerError(vm) {
  return vm.$el && vm.$el.getAttribute('class') && vm.$el.getAttribute('class').includes('datepicker-container');
}

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
